import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { LiquidAsset } from 'src/app/models/liquid-asset-response.model'

@Injectable({
  providedIn: 'root',
})
export class LiquidAssetService {
  public static readonly liquidAssetEndpoint = '/liquidAsset'

  constructor(private readonly http: HttpClient) {}

  getLiquidAsset(fundId: string): Observable<LiquidAsset> {
    return this.http.get<LiquidAsset>(
      `vmf/api/${fundId}`.concat(LiquidAssetService.liquidAssetEndpoint),
    )
  }
}
